import { Component, Input} from '@angular/core';

@Component({
    selector: 'dx-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    standalone: false
})
export class BadgeComponent {
    @Input() value: string = "";
    @Input() size!: "large" | "xlarge";
    @Input() severity!: "warn" | "success" | "danger" | "info";
    ngOnInit() {
       
    }

}
